import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Save original fetch
const originalFetch = window.fetch;

// Override global fetch to automatically add Authorization header
window.fetch = async function(url, options = {}) {
  // Convert url to string for route checking
  const urlString = typeof url === 'string' ? url : url.url || url.toString();
  
  // Skip for public routes that don't need authentication
  const publicRoutes = [
    '/api/auth/login',
  ];
  
  const isPublicRoute = publicRoutes.some(route => 
    urlString.includes(route)
  );
  
  // Only add Authorization header for non-public routes
  if (!isPublicRoute) {
    const token = localStorage.getItem('token');
    if (token) {
      const headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
      };
      
      options = {
        ...options,
        headers,
      };
    }
  }
  
  // Call original fetch
  return originalFetch(url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
